import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from 'react-router-dom';
import { TextField, Button, Grid, Typography, Container, Dialog, DialogTitle, DialogContent, DialogActions,Select, MenuItem } from "@mui/material";

const BlogAdmin = () => {
  const [blogs, setBlogs] = useState([]);
  const [formData, setFormData] = useState({
    title: "",
    slug: "",
    meta_title: "",
    meta_description: "",
    content: "",
    instagrampostid: "", // Varsayılan olarak boş değer
  });
  
  const [editData, setEditData] = useState(null); // Edit modunda kullanılacak veriler
  const [isEditModalOpen, setIsEditModalOpen] = useState(false); // Modal kontrolü
  const navigate = useNavigate();
  const [unmatchedPosts, setUnmatchedPosts] = useState([]);
  const [translations, setTranslations] = useState([]); // Çevirileri saklayacak state
  const [selectedBlog, setSelectedBlog] = useState(null); // Çeviri eklenirken seçilen blog
  const [newTranslation, setNewTranslation] = useState({
    language: "en",
    title: "",
    meta_title: "",
    meta_description: "",
    content: "",
  });
  const [editingTranslation, setEditingTranslation] = useState(null);
  const [isTranslationModalOpen, setIsTranslationModalOpen] = useState(false);
  const api = axios.create({
    baseURL: process.env.REACT_APP_API_BASE_URL,
  });

  // get unmatched instagram posts
  useEffect(() => {
    const fetchUnmatchedPosts = async () => {
      try {
        const response = await api.get('/api/instagram/unmatched');
        setUnmatchedPosts(response.data);
      } catch (error) {
        console.error('Error fetching unmatched Instagram posts:', error.message);
      }
    };
    fetchUnmatchedPosts();
  }, []);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user || user.email !== ('emreonyurt@gmail.com' && 'emre5@gmail.com')  ) {
      alert('Access denied.');
      navigate('/projects'); // Redirect to projects page
    }
  }, []);

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const response = await api.get("/api/blog/admin");
        setBlogs(response.data);
      } catch (error) {
        console.error("Error fetching blogs:", error.message);
      }
    };

    fetchBlogs();
  }, []);


  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/api/blog", formData); // formData içinde instagrampostid dahil
      alert("Blog added successfully!");
      setFormData({ title: "", slug: "", meta_title: "", meta_description: "", content: "", instagrampostid: "" });
      const response = await api.get("/api/blog/admin");
      setBlogs(response.data);
      // Sitemap'i güncelle
      await api.get("/api/sitemap/generate");
      alert("Sitemap updated successfully!");
    } catch (error) {
      console.error("Error adding blog:", error.message);
    }
  };
  

  const handleDelete = async (id) => {
    try {
      await api.delete(`/api/blog/${id}`);
      alert("Blog deleted successfully!");
      setBlogs(blogs.filter((blog) => blog.id !== id));
      await api.get("/api/sitemap/generate"); // Yeni bir endpoint çağrısı
      alert("Sitemap updated successfully!");
    } catch (error) {
      console.error("Error deleting blog:", error.message);
    }
  };


  const handleEdit = (blog) => {
    setEditData({
      ...blog,
      instagrampostid: blog.instagrampostid || "", // Null ise boş değer atıyoruz
    });
    setIsEditModalOpen(true);
  };
  

  const handleEditSubmit = async () => {
    try {
      await api.put(`/api/blog/${editData.id}`, editData); // editData içinde instagrampostid dahil
      alert("Blog updated successfully!");
      setIsEditModalOpen(false);
      const response = await api.get("/api/blog/admin");
      setBlogs(response.data);
      // Sitemap'i güncelle
      await api.get("/api/sitemap/generate");
      alert("Sitemap updated successfully!");
    } catch (error) {
      console.error("Error updating blog:", error.message);
    }
  };

  // ✅ Belirli bir blogun çevirilerini getir
  const fetchTranslations = async (blogId) => {
    try {
      const response = await api.get(`/api/blog/${blogId}/translations`);
      setTranslations(response.data);
    } catch (error) {
      console.error("Error fetching translations:", error.message);
    }
  };

  // ✅ Çeviri düzenleme ekranını aç
  const handleEditTranslation = (translation) => {
    setEditingTranslation(translation);
    setIsTranslationModalOpen(true);
  };

  // ✅ Yeni çeviri ekleme ekranını aç
  const handleAddTranslation = (blog) => {
    setSelectedBlog(blog);
    setEditingTranslation({ blog_id: blog.id, language: "en", title: "", meta_title: "", meta_description: "", content: "" });
    setIsTranslationModalOpen(true);
  };

  // ✅ Çeviri ekleme/güncelleme işlemi
  const handleSaveTranslation = async () => {
    try {
      if (editingTranslation.id) {
        // Güncelleme
        await api.put(`/api/blog/${editingTranslation.blog_id}/translations/${editingTranslation.id}`, editingTranslation);
        alert("Translation updated successfully!");
      } else {
        // Yeni ekleme
        await api.post(`/api/blog/${editingTranslation.blog_id}/translations`, editingTranslation);
        alert("Translation added successfully!");
      }

      setIsTranslationModalOpen(false);
      fetchTranslations(editingTranslation.blog_id); // Çevirileri tekrar getir
    } catch (error) {
      console.error("Error saving translation:", error.message);
    }
  };
  
  return (
    <Container maxWidth="md" style={{ marginTop: "30px" }}>
      <Typography variant="h4" align="center" gutterBottom>
        Blog Admin Panel
      </Typography>

      {/* Add Blog Form */}
      <form onSubmit={handleSubmit} style={{ marginTop: "30px" }}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="h6">Add New Blog</Typography>
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Title"
              fullWidth
              value={formData.title}
              onChange={(e) => setFormData({ ...formData, title: e.target.value })}
              required
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="URL Slug"
              fullWidth
              value={formData.slug}
              onChange={(e) => setFormData({ ...formData, slug: e.target.value })}
              required
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Meta Title"
              fullWidth
              value={formData.meta_title}
              onChange={(e) => setFormData({ ...formData, meta_title: e.target.value })}
              required
            />
          </Grid>

          <Grid item xs={6}>
            <TextField
              label="Meta Description"
              fullWidth
              multiline
              rows={3}
              value={formData.meta_description}
              onChange={(e) => setFormData({ ...formData, meta_description: e.target.value })}
              required
            />
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Content (HTML)"
              fullWidth
              multiline
              rows={6}
              value={formData.content}
              onChange={(e) => setFormData({ ...formData, content: e.target.value })}
              required
            />
          </Grid>
          <Grid item xs={6}>
            <Typography variant="h6">Select Instagram Post</Typography>
            <select
              value={formData.instagrampostid || ""}
              onChange={(e) => setFormData({ ...formData, instagrampostid: e.target.value })}
              style={{ width: "100%", padding: "10px", marginTop: "10px" }}
            >
              <option value="">Select Instagram Post</option>
              {unmatchedPosts.map((post) => (
                <option value={post.id} key={post.id}>
                  {post.caption}
                </option>
              ))}
            </select>
          </Grid>


          <Grid item xs={12}>
            <Button type="submit" variant="contained" color="primary" fullWidth>
              Add Blog
            </Button>
          </Grid>
        </Grid>
      </form>

      {/* Blog List */}
      <Typography variant="h6" style={{ marginTop: "50px" }}>
        All Blogs
      </Typography>
      <Grid container spacing={2} style={{ marginTop: "20px" }}>
        <Grid item xs={12}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr>
                <th style={{ textAlign: "left", padding: "10px", borderBottom: "1px solid #ccc" }}>Title</th>
                <th style={{ textAlign: "left", padding: "10px", borderBottom: "1px solid #ccc" }}>Slug</th>
                <th style={{ textAlign: "left", padding: "10px", borderBottom: "1px solid #ccc" }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {blogs.map((blog) => (
                <tr key={blog.id}>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>{blog.title}</td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>{blog.slug}</td>
                  <td style={{ padding: "10px", borderBottom: "1px solid #ccc" }}>
                  <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={() => fetchTranslations(blog.id)}
                      style={{ marginRight: "10px" }}
                    >
                      View Translations
                    </Button>
                  <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={() => handleAddTranslation(blog)}
                      style={{ marginRight: "10px" }}
                    >
                      Add Translation
                    </Button>
                    <Button
                      variant="outlined"
                      color="primary"
                      size="small"
                      onClick={() => handleEdit(blog)}
                      style={{ marginRight: "10px" }}
                    >
                      Edit
                    </Button>
                    <Button
                      variant="outlined"
                      color="error"
                      size="small"
                      onClick={() => handleDelete(blog.id)}
                    >
                      Delete
                    </Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </Grid>
      </Grid>

      {/* Edit Modal */}
      <Dialog open={isEditModalOpen} onClose={() => setIsEditModalOpen(false)}>
        <DialogTitle>Edit Blog</DialogTitle>
        <DialogContent>
          <TextField
            label="Title"
            fullWidth
            margin="normal"
            value={editData?.title || ""}
            onChange={(e) => setEditData({ ...editData, title: e.target.value })}
          />
          <TextField
            label="URL Slug"
            fullWidth
            margin="normal"
            value={editData?.slug || ""}
            onChange={(e) => setEditData({ ...editData, slug: e.target.value })}
          />
          <TextField
            label="Meta Title"
            fullWidth
            margin="normal"
            value={editData?.meta_title || ""}
            onChange={(e) => setEditData({ ...editData, meta_title: e.target.value })}
          />
          <TextField
            label="Meta Description"
            fullWidth
            margin="normal"
            multiline
            rows={3}
            value={editData?.meta_description || ""}
            onChange={(e) => setEditData({ ...editData, meta_description: e.target.value })}
          />
          <TextField
            label="Content (HTML)"
            fullWidth
            margin="normal"
            multiline
            rows={6}
            value={editData?.content || ""}
            onChange={(e) => setEditData({ ...editData, content: e.target.value })}
          />
          <Typography variant="h6" style={{ marginTop: "10px" }}>Select Instagram Post</Typography>
          <select
            value={editData?.instagrampostid || ""}
            onChange={(e) => setEditData({ ...editData, instagrampostid: e.target.value })}
            style={{ width: "100%", padding: "10px", marginTop: "10px" }}
          >
            <option value="">Select Instagram Post</option>
            {unmatchedPosts.map((post) => (
              <option value={post.id} key={post.id}>
                {post.caption}
              </option>
            ))}
          </select>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsEditModalOpen(false)} color="secondary">
            Cancel
          </Button>
          <Button onClick={handleEditSubmit} variant="contained" color="primary">
            Save Changes
          </Button>
        </DialogActions>
      </Dialog>

      {/* Translation List */}
      {translations.length > 0 && (
        <>
          <Typography variant="h6" style={{ marginTop: "30px" }}>Translations</Typography>
          <Grid container spacing={2} style={{ marginTop: "10px" }}>
            {translations.map((translation) => (
              <Grid item xs={12} key={translation.id}>
                <div style={{ padding: "10px", border: "1px solid #ccc", borderRadius: "5px" }}>
                  <p><strong>Language:</strong> {translation.language}</p>
                  <p><strong>Title:</strong> {translation.title}</p>
                  <Button
                    variant="outlined"
                    color="primary"
                    size="small"
                    onClick={() => handleEditTranslation(translation)}
                  >
                    Edit Translation
                  </Button>
                </div>
              </Grid>
            ))}
          </Grid>
        </>
      )}

      {/* Add Translation Modal */}
      {/* Translation Modal */}
      <Dialog open={isTranslationModalOpen} onClose={() => setIsTranslationModalOpen(false)}>
        <DialogTitle>{editingTranslation?.id ? "Edit Translation" : "Add Translation"}</DialogTitle>
        <DialogContent>
          <Select
            value={editingTranslation?.language}
            fullWidth
            margin="normal"
            onChange={(e) => setEditingTranslation({ ...editingTranslation, language: e.target.value })}
          >
            <MenuItem value="en">English</MenuItem>
            <MenuItem value="ar">Arabic</MenuItem>
            <MenuItem value="es">Spanish</MenuItem>
            <MenuItem value="it">Italian</MenuItem>
            <MenuItem value="tr">Turkish</MenuItem>
            <MenuItem value="de">German</MenuItem>
            <MenuItem value="fr">French</MenuItem>
          </Select>

          <TextField
            label="Title"
            fullWidth
            margin="normal"
            value={editingTranslation?.title}
            onChange={(e) => setEditingTranslation({ ...editingTranslation, title: e.target.value })}
          />
          <TextField
            label="Meta Title"
            fullWidth
            margin="normal"
            value={editingTranslation?.meta_title}
            onChange={(e) => setEditingTranslation({ ...editingTranslation, meta_title: e.target.value })}
          />
          <TextField
            label="Meta Description"
            fullWidth
            margin="normal"
            multiline
            rows={3}
            value={editingTranslation?.meta_description}
            onChange={(e) => setEditingTranslation({ ...editingTranslation, meta_description: e.target.value })}
          />
          <TextField
            label="Content (HTML)"
            fullWidth
            margin="normal"
            multiline
            rows={6}
            value={editingTranslation?.content}
            onChange={(e) => setEditingTranslation({ ...editingTranslation, content: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setIsTranslationModalOpen(false)} color="secondary">Cancel</Button>
          <Button onClick={handleSaveTranslation} variant="contained" color="primary">Save</Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default BlogAdmin;
